import { PRICING_MODEL } from '../../../../config';
import BID_STRATEGIES from '../bidStrategies';
import campaignInitialValues from './campaignInitialValues';

export const openExchangeCampaignInitialValues = {
    ...campaignInitialValues,
    pricingModel: PRICING_MODEL.VCPM,
    bidStrategy: BID_STRATEGIES.FIXED,
};
